import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { HttpModule } from '@angular/http';

import { PrivacyComponent } from './privacy.component';
import { PrivacyService } from './privacy.service';
import { PrivacyRoutingModule } from './privacy-routing.module';


@NgModule({ declarations: [
        PrivacyComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PrivacyRoutingModule
        // HttpModule
    ], providers: [PrivacyService, provideHttpClient(withInterceptorsFromDi())] })
export class PrivacyModule { }
